import { createFileRoute } from "@tanstack/react-router";
import { AlertCircle, Loader2 } from "lucide-react";
import { NpsApplicationForm } from "@/components/nps/form";
import { useNPSApplication } from "@/hooks/queries/use-nps-application";

export const Route = createFileRoute("/avaliacao/$id")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	const {
		data: npsApplication,
		isLoading,
		isError,
		error,
	} = useNPSApplication(id);

	if (isLoading) {
		return (
			<div className="flex min-h-[50vh] w-full items-center justify-center">
				<Loader2 className="h-8 w-8 animate-spin text-primary" />
			</div>
		);
	}

	if (isError) {
		const errorStatus =
			(error as { response?: { status?: number }; status?: number })?.response
				?.status ||
			(error as { response?: { status?: number }; status?: number })?.status;
		const isForbidden = errorStatus === 401 || errorStatus === 403;

		return (
			<div className="flex w-full items-center justify-center p-8">
				<div className="flex max-w-md flex-col items-center gap-4 rounded-lg border border-destructive/50 bg-destructive/10 p-6 text-center text-destructive">
					<AlertCircle className="h-8 w-8" />
					<h2 className="text-lg font-semibold">
						{isForbidden ? "Acesso Negado" : "Erro"}
					</h2>
					<p className="text-sm">
						{isForbidden
							? "Você não tem permissão para visualizar esta avaliação."
							: "Ocorreu um erro ao carregar os dados da avaliação."}
					</p>
				</div>
			</div>
		);
	}

	if (!npsApplication) {
		return (
			<div className="flex w-full items-center justify-center p-8">
				<div className="flex max-w-md flex-col items-center gap-4 rounded-lg border p-6 text-center text-muted-foreground">
					<AlertCircle className="h-8 w-8" />
					<h2 className="text-lg font-semibold">Não Encontrada</h2>
					<p className="text-sm">Avaliação não encontrada.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="mx-auto flex w-full max-w-7xl flex-auto justify-center px-4 py-8 relative">
			{/* Sidebar Navigation */}
			<div className="hidden xl:block xl:w-64 xl:flex-none xl:mr-8 xl:sticky xl:top-8 h-fit">
				<div className="rounded-lg border bg-card text-card-foreground p-6 shadow-sm">
					<h3 className="font-semibold mb-4">Navegue pela avaliação</h3>
					<nav className="flex flex-col space-y-2">
						<a
							href="#nps-form"
							className="text-sm font-medium hover:underline text-primary"
						>
							Avaliação Geral
						</a>
						{npsApplication.teachersOrder.map((teacherOrder) => {
							const title = npsApplication.application.showTeahcerName
								? `${teacherOrder.teacherSubject.teacher.name} - ${teacherOrder.teacherSubject.subject.name}`
								: teacherOrder.teacherSubject.subject.name;

							return (
								<a
									key={teacherOrder.id}
									href={`#${teacherOrder.id}`}
									className="text-sm text-muted-foreground hover:text-foreground"
								>
									{title}
								</a>
							);
						})}
					</nav>
				</div>
			</div>

			{/* Content */}
			<div className="w-full max-w-4xl flex-1">
				<NpsApplicationForm nPSApplication={npsApplication} />
			</div>
		</div>
	);
}
